import catchAsync from "../../utils/catchAsync";
import httpsCall from "../httpsCall";

type JobPostData = {
    title: string;
    category: string;
    type: string;
    salaryMin: string;
    salaryMax: string;
    experience: string;
    qualification: string;
    skill: string;
    des_skills: string,
    responsibilities: string,
    vacancy: string;
    location: string;
    deadlineDate: string;
    description: string;
};

export const JobPostApi = catchAsync(async (values: JobPostData) => {  
    const data = await httpsCall.post(`job/job-add`, values);
    return data;
});

export const ManageJobApi = catchAsync(async (currentPage) => {  
    const data = await httpsCall.get(`job/emp-job-list/${currentPage}/10`);
    return data;
});

export const DeleteJobApi = catchAsync(async (jobId) => {  
    const data = await httpsCall.delete(`job/job-delete/${jobId}`);
    return data;
});

export const viewJobApi = catchAsync(async (jobId) => {  
    const data = await httpsCall.get(`job/emp-job-detail/${jobId}`);
    return data;
});

export const updateJobApi = catchAsync(async (jobId, values: JobPostData) => {  
    const data = await httpsCall.patch(`job/job-update/${jobId}`, values);
    return data;
});

export const jobCategoryApi = catchAsync(async () => {  
    const data = await httpsCall.get(`category-type/category-list`);
    return data;
});

export const jobTypeApi = catchAsync(async () => {  
    const data = await httpsCall.get(`category-type/type-list`);
    return data;
});

export const jobSalaryRangeApi = catchAsync(async () => {  
    const data = await httpsCall.get(`category-type/salary-min-max`);
    return data;
});